var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _circle2, _circle3, _line, _path18, _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureCustomAvailability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6962 41.2885C54.2403 40.7738 55.9559 40.4307 57.6716 40.4307",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6324 48.6669C45.3187 47.1228 46.3481 45.7503 47.5491 44.5493",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2891 59.4754C43.7744 57.9313 43.4313 56.2157 43.4313 54.5",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4946 67.3673C49.9505 66.681 48.5779 65.6517 47.377 64.4507",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3034 67.8823C60.7593 68.397 59.0437 68.7402 57.328 68.7402",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3672 60.332C69.6809 61.8761 68.6515 63.4202 67.4506 64.6212",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7104 49.6968C71.2251 51.2409 71.5683 52.9565 71.5683 54.6722",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3335 41.6323C64.8776 42.3186 66.4217 43.348 67.6227 44.549",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5005 40.4313L59.2162 37L63.6769 38.0294L63.5053 41.6323",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5494 44.549L46.3484 40.9461L50.2944 38.3726L52.6964 41.2892",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4313 54.4994L40 52.7837L41.0294 48.323L44.6323 48.6661",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3768 64.4496L43.9454 65.6505L41.3719 61.8761L44.2886 59.4741",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 68.7402L55.7843 72L51.3236 70.9706L51.4952 67.3677",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4503 64.6216L68.6513 68.2245L64.7053 70.6264L62.3033 67.8813",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5685 54.6709L74.9999 56.3866L73.9705 60.8473L70.3676 60.5042",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6226 44.5498L71.0539 43.3489L73.6274 47.2949L70.7108 49.6968",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 60.5C61.0899 60.5 64 57.5898 64 54C64 50.4101 61.0899 47.5 57.5 47.5C53.9102 47.5 51 50.4101 51 54C51 57.5898 53.9102 60.5 57.5 60.5Z",
    stroke: "#06ADEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 18.5,
    r: 2,
    fill: "#2C3549"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 18.5,
    r: 2,
    fill: "#2C3549"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18.5,
    r: 2,
    fill: "#2C3549"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 24,
    x2: 80,
    y2: 24,
    stroke: "#2C3549",
    strokeWidth: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 66.5H8C5.23858 66.5 3 64.2614 3 61.5V17.5C3 14.7386 5.23858 12.5 8 12.5H75C77.7614 12.5 80 14.7386 80 17.5V39.5",
    stroke: "#2C3549",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 64.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#2C3549"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 37.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#2C3549"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 32,
    width: 10,
    height: 10,
    rx: 2,
    stroke: "#06ADEF",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 47.5,
    width: 11,
    height: 11,
    rx: 2.5,
    stroke: "#2C3549"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 31.5,
    width: 11,
    height: 11,
    rx: 2.5,
    stroke: "#2C3549"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureCustomAvailability);
export default __webpack_public_path__ + "static/media/feature-custom-availability.4a7d39fe.svg";
export { ForwardRef as ReactComponent };